module.exports = __webpack_public_path__ + "img/exchange_color.ac1eed8a.png";